import {Modal} from 'react-bootstrap'
import {ToastMessageContainer} from '../../../../../../_ePulse/layout/components/ToastMessageContainer'
import {useNavigate} from 'react-router-dom'

export const DownloadPdfModal = (props: any) => {
  const navigate = useNavigate()
  return (
    <Modal
      show={true}
      dialogClassName='ePulse-modal ePulse-modal-50w'
      // onHide={() => props.onClose()}
      // backdrop='static'
    >
      <Modal.Header className='border-0 d-flex justify-content-start'>
        <div>
          <ToastMessageContainer />
        </div>
        <div className='fs-3 fw-bold'>Do you want to download Receipt?</div>
      </Modal.Header>
      <Modal.Body>
        <div className='d-flex justify-content-end gap-3' style={{}}>
          <button
            className='ePulse-btn-primary mb-3'
            type='button'
            onClick={() => {
              if (props.pdfUrl) {
                window.open(props.pdfUrl, '_blank')
                navigate('/scancenter/dashboard')
              }
            }}
            disabled={!props.pdfUrl}
          >
            Download Receipt
          </button>

          <button
            className='ePulse-btn-primary mb-3'
            type='button'
            onClick={() => {
              props.onClose()
              navigate('/scancenter/dashboard')
            }}
          >
            Close
          </button>
        </div>
      </Modal.Body>
    </Modal>
  )
}
